<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-4.h6.basic800--text {{ $t('select_salesperson') }}
      v-divider.basic300
      v-card-text.px-4.text-center
        v-text-field.mt-4(v-model="searchText" :placeholder="$t('search_member')" hide-details dense outlined height="40" background-color="basic200")
          template(v-slot:append)
            eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
        div
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          .content(v-else)
            v-layout.my-6(v-if="forms.length == 0")
              v-row.fill-height.ma-0(align='center' justify='center')
                div.mx-auto
                  v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                  p.caption {{ $t('members_not_found') }}
            div.mt-4(v-else)
              v-card(outlined)
                v-list.pa-0
                  div(v-for='(member, index) in forms')
                    v-divider(v-if="index != 0")
                    v-list-item(:key='member.id' @click="selectItem(member)" style="min-height: 74px")
                      v-layout.text-left
                        intel-avatar.mr-3.my-auto(:code="member.user.avatar_code" :id="member.user.id" size=48)
                        v-list-item-content
                          v-list-item-title.s1.basic800--text {{ `${member.user.first_name} ${member.user.last_name} (${member.role})` }}
                          v-list-item-subtitle
                            div.c1.basic600--text
                              span.mr-2 {{ $t('leads') }}: {{ member.total_leads }}
                              span.mr-2 {{ $t('sales') }}: {{ member.total_sales | displayPrice }}

              div.mt-4
                y-pagination.ma-4(v-model="page" :pageSize="fetchCount" :count="totalCount")

      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('close') }}

</template>

<script>
import { mapActions } from 'vuex'
import IntelAvatar from '@/components/IntelAvatar.vue'
export default {
  name: 'MemberFilterDialog',
  props: ['open', 'company'],
  components: { IntelAvatar },
  data: () => ({
    isFetching: true,
    fetchCount: 10,
    page: 1,
    totalPage: 1,
    searchText: '',
    forms: [],
    totalCount: 0,
    searchCountDown: null,
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    page (val) {
      if (!this.isFetching) {
        this.fetchForms(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  mounted () {
    this.fetchForms(1)
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchForms(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/members/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-total_sales&exclude_roles=5`
      this.$axios.get(url)
        .then(response => {
          this.forms = response.data.results
          this.totalCount = response.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    searchItem () {
      let searchUrl = searchUrl = `/members/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-total_sales&exclude_roles=5`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.forms = response.data.results
          this.totalCount = response.data.count
        }).catch(() => {})
    },
    selectItem (form) {
      this.showModal = false
      this.$emit('selected', form)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "select_salesperson": "Select Salesperson"
  },
  "id": {
    "select_salesperson": "Pilih Salesperson/Penjual"
  }
}
</i18n>